<template>
  <div
    class="manage-content page-card-wrapper page-card-wrapper-adapt-actual-width"
  >
    <div class="page-card-title">
      <span class="page-card-title-text">{{ $t('text.pods_location') }}</span>
    </div>
    <div class="page-card-content">
      <div class="mt-20">
        <div class="section-title">
          <el-button
            type="success"
            plain
            class="common-btn"
            @click="addPod()"
            v-if="p('Devices.Pod.Add')"
            >{{ $t('text.add_pod').toUpperCase() }}</el-button
          >
          <span class="right-float">
            <svg-icon
              iconClass="filter"
              className="content-element-color-more-lighter"
            ></svg-icon>
            <el-input
              v-model="filter"
              size="mini"
              class="search-input filter-input"
              :placeholder="$t('text.filter_pod')"
            ></el-input>
          </span>
        </div>
        <el-table
          border
          ref="table"
          :data="tableData"
          v-loading="loading"
          class="mt-20"
        >
          <el-table-column
            :label="$t('text.pod_serial_number')"
            prop="AllocatedPod"
          >
          </el-table-column>
          <el-table-column
            :label="$t('text.version') | firstLetterCapitalize"
            prop="FirmwareVersion"
          >
            <template slot-scope="scope">
              <span
                v-if="scope.row.FirmwareVersion"
                :class="
                  !latestVersion ||
                  scope.row.FirmwareVersion.replace(/^v/i, '').toLowerCase() ===
                    latestVersion.replace(/^v/i, '').toLowerCase()
                    ? 'blackish-green-font'
                    : 'red-font'
                "
                >{{ scope.row.FirmwareVersion }}</span
              >
            </template>
          </el-table-column>
          <el-table-column :label="$t('text.action')" width="350">
            <template slot-scope="scope">
              <div
                class="blue-font underline pointer mr-10 inline-block"
                @click="recordPodChange(scope.row)"
              >
                {{ $t('text.record_pod_change') }}
              </div>
              <div
                class="blue-font underline pointer mr-10 inline-block"
                @click="podChangeHistory(scope.row)"
              >
                {{ $t('text.pod_change_history') }}
              </div>
              <div
                class="red-font underline pointer inline-block"
                @click="podChangeHistory(scope.row)"
                v-if="p('Devices.Pod.Delete')"
              >
                {{ $t('text.delete') | firstLetterCapitalize }}
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <AddPod ref="addPod" />
    <RecordPodChange ref="recordPodChange" />
    <PodChangeHistory ref="podChangeHistory" />
  </div>
</template>

<script>
import AddPod from '@/components/nodes/AddPod'
import RecordPodChange from '@/components/nodes/RecordPodChange'
import PodChangeHistory from '@/components/nodes/PodChangeHistory'
import ApiService from '@/services/ApiService.js'
import swal from 'sweetalert'
import { podSerialNumberDisplayPrefix } from '@/const'

export default {
  data() {
    return {
      loading: false,
      tableData: [],
      filter: '',
      timer: '',
      latestVersion: null
    }
  },
  components: {
    AddPod,
    RecordPodChange,
    PodChangeHistory
  },
  mounted: function() {
    this.getLatestVersion()
    this.getData()
  },
  watch: {
    '$store.state.site.selectedSite': function() {
      this.getData()
    },
    filter() {
      if (this.timer) {
        clearTimeout(this.timer)
      }
      this.timer = setTimeout(this.getData, 500)
    }
  },
  methods: {
    getLatestVersion() {
      ApiService.GetFwVerV2('ota').then(response => {
        if (response.data.success) {
          this.latestVersion = response.data.data.version
        } else {
          swal({
            icon: 'error',
            timer: 2000,
            title: this.$t('text.failed'),
            text: response.data.msg
          })
        }
      })
    },
    getData() {
      if (!this.$store.getters[`user/selecteOrganisationId`]) return false
      this.tableData = []
      this.loading = true
      ApiService.GetSitePods(
        this.$store.getters[`user/selecteOrganisationId`]
      ).then(response => {
        this.loading = false
        if (response.data.success) {
          this.tableData = response.data.data.map(item => {
            return {
              ...item,
              AllocatedPod:
                podSerialNumberDisplayPrefix +
                item.MacAddress.substring(item.MacAddress.length - 4)
            }
          })
          if (this.filter) {
            this.tableData = this.tableData.filter(item => {
              return (
                item.AllocatedPod.toLowerCase().indexOf(
                  this.filter.toLowerCase()
                ) > -1
              )
            })
          }
        } else {
          this.loading = false
          swal({
            icon: 'error',
            timer: 2000,
            title: this.$t('text.failed'),
            text: response.data.msg
          })
        }
      })
    },
    addPod() {
      this.$refs.addPod.openDialog()
    },
    deleteRow(item) {
      let warningIconUrl = require('@/assets/image/warning-icon/warning.svg')
      this.$confirm(
        `<div class='warning-content'>${this.$t(
          'text.delete_pod_warning'
        )}</div><img class='warning-icon' src=${warningIconUrl}>`,
        this.$t('text.you_able_to_delete_data') + ' ' + item.AllocatedPod,
        {
          confirmButtonText: this.$t('text.delete').toUpperCase(),
          cancelButtonText: this.$t('text.cancel').toUpperCase(),
          confirmButtonClass: 'confirm-btn',
          cancelButtonClass: 'cancel-btn',
          type: 'warning',
          customClass: 'delete-warning-box',
          showClose: true,
          closeOnClickModal: false,
          dangerouslyUseHTMLString: true
        }
      )
        .then(() => {
          this.handleDelete(item)
        })
        .catch(() => {})
    },
    handleDelete(item) {
      this.loading = true
      ApiService.DeleteSitePod(
        this.$store.getters[`user/selecteOrganisationId`],
        item.MacAddress
      ).then(response => {
        this.loading = false
        if (response.data.success) {
          this.getData()
        } else {
          swal({
            icon: 'error',
            timer: 2000,
            title: this.$t('text.failed'),
            text: response.data.msg
          })
        }
      })
    },
    recordPodChange(item) {
      this.$refs.recordPodChange.openDialog(item)
    },
    podChangeHistory(item) {
      this.$refs.podChangeHistory.openDialog(item)
    }
  }
}
</script>
